<router-outlet></router-outlet>
<app-toast></app-toast>
<app-install-prompt></app-install-prompt>
<app-install-guide-modal></app-install-guide-modal>
<app-contextual-help-modal></app-contextual-help-modal>
<app-support-modal></app-support-modal>
